import React from 'react'
import L from 'leaflet'
import { Map, Marker, Polyline, TileLayer } from 'react-leaflet'
import '../scss/MapaFavoritos.css'
import {along} from '../utils/map'
import CONFIG from '../config'

class MapaFavoritos extends React.Component {
  //
  // ...
  constructor (props) {
    super(props)
    // updateMapBounds: 1
    // Forzamos a primeira vez a centrar o mapa!!!
    // Se non aparece un mapa blanco e empezan a facerse peticións
    // a archivos js en vez de "tiles" que bloquean o navegador.
    this.state = {
      time: 0,
      updateMapBounds: 1
    }
    this.favoritosCoords = {}
  }

  /*
  componentDidMount () {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 250)
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
  */

  UNSAFE_componentWillReceiveProps (nextProps, nextState) { // eslint-disable-line
    let updateMapBounds = 0
    if (nextProps.turfBounds !== this.props.turfBounds) {
      // Unicamente forzamos al mapa a usar "fitBounds" la primera vez que se dibuja
      // console.info('turfBounds')
      updateMapBounds = 1
    }
    // console.info(updateMapBounds)
    if (this.state.updateMapBounds !== updateMapBounds) {
      this.setState({
        updateMapBounds: updateMapBounds
      })
    }
  }

  render () {
    // console.info('MapaFavoritos.render')
    // console.info(this.state.updateMapBounds)
    // const position = [42.34394, -7.8728]

    // vai haber que facer algo con turfDistanceRelation para cada sector!!!
    const {
      resultados, geoJson, turfLine, turfBounds, turfDistanceRelation,
      sectores, controles
    } = this.props

    let colorIndex = -1
    const colorValuesLength = CONFIG.COLORES_FAVORITOS.length

    const iconoSalida = new L.Icon({
      iconUrl: '/img/ico-salida-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })
    const iconoMeta = new L.Icon({
      iconUrl: '/img/ico-meta-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })
    const iconoControl = new L.Icon({
      iconUrl: '/img/ico-control-v2.png',
      iconSize: [22, 35],
      iconAnchor: [11, 35],
      popupAnchor: null,
      shadowUrl: null,
      shadowSize: null,
      shadowAnchor: null
    })

    // Map layers https://wms.ccnorte.es/demo
    let mapBounds = null
    if (this.state.updateMapBounds === 1 && turfBounds && turfBounds.length === 4) {
      mapBounds = [ [ turfBounds[ 0 ], turfBounds[ 1 ] ], [ turfBounds[ 2 ], turfBounds[ 3 ] ] ]
      // console.info(mapBounds)
    }
    // console.info(mapBounds)
    let controlMarkers = []
    if (sectores && sectores.length) {
      controlMarkers = controles.map((control) => {
        let i
        for (i = 0; i < sectores.length; i++) {
          const s = sectores[i]
          if (parseInt(control.distancia, 10) >= s.inicio_metros && parseInt(control.distancia, 10) <= s.fin_metros) {
            if (control.vuelta === 1 && control.visible && control.tipo !== 'META' && control.tipo !== 'SALIDA') {
              if (turfLine[i] && geoJson[i]) {
                const punto = along(turfLine[i], (control.distancia - s.inicio_metros) / 1000.0 / s.turfDistanceRelation)
                // console.info(punto)
                return <Marker position={punto.geometry.coordinates} icon={iconoControl} key={`control-${control.id}`} />
              }
            }
          }
        }
        return null
      }).filter((r) => r !== null)
    } else {
      controlMarkers = controles.map((control) => {
        // console.info(control)
        if (control.vuelta === 1 && control.visible && control.tipo !== 'META' && control.tipo !== 'SALIDA') {
          // console.info(control.distancia / turfDistanceRelation)
          if (turfLine) {
            const punto = along(turfLine, control.distancia / 1000.0 / turfDistanceRelation)
            // console.info(punto)
            return <Marker position={punto.geometry.coordinates} icon={iconoControl} key={`control-${control.id}`} />
          }
        }
        return null
      }).filter((r) => r !== null)
    }

    // @fixme: Comprobar se hai sectores fora do map
    const MapMarkers = resultados.map((resultado) => {
      colorIndex++
      let colorValue = CONFIG.COLORES_FAVORITOS[ colorIndex % colorValuesLength ]

      if (resultado.prevision.tiempo) {
        const customMarker = L.divIcon({
          className: 'mapa__marker ',
          iconSize: null,
          html: '<div ' +
            'class="mapa__marker__icono" style="background-color: ' + colorValue + '">' +
            resultado.nombre[0].toUpperCase() + (resultado.apellidos ? resultado.apellidos[0].toUpperCase() : '') +
            '</div>' +
            '<div class="mapa__marker__arrow" />'
        })

        let previsionPunto = null
        if (sectores.length) {
          if (sectores[resultado.prevision.sector_idx]) {
            const geo = geoJson[resultado.prevision.sector_idx]
            if (resultado.prevision.porcentaje === 100) {
              previsionPunto = geo[geo.length - 1]
            } else {
              const previsionPoint = along(
                turfLine[resultado.prevision.sector_idx],
                resultado.prevision.distancia / 1000.0 / resultado.prevision.sector.turfDistanceRelation
              )
              previsionPunto = previsionPoint ? previsionPoint.geometry.coordinates : null
            }
          } else {
            delete resultado['prevision']
          }
        } else {
          if (resultado.prevision.porcentaje === 100) {
            previsionPunto = geoJson[ geoJson.length - 1 ]
          } else {
            const previsionPoint = along(
              turfLine,
              (resultado.prevision.distancia - resultado.prevision.inicioDistancia) / 1000.0 / turfDistanceRelation
            )
            // console.info(previsionPoint.geometry.coordinates)
            previsionPunto = previsionPoint ? previsionPoint.geometry.coordinates : null
          }
        }

        if (!previsionPunto) {
          return null
        }
        // Para poder ajustar el mapa a estas coordenadas
        this.favoritosCoords[resultado.dorsal] = previsionPunto
        // ...
        return <Marker icon={customMarker} position={previsionPunto} key={`resultado-${resultado.dorsal}`} />
      } else {
        return null
      }
    })

    // console.info(mapBounds)
    // console.info(geoJson)
    return <div>
      <Map bounds={mapBounds} boundsOptions={{padding: [0, 0]}}>
        <TileLayer
          url={CONFIG.MAP_LAYER}
        />
        {controlMarkers}
        {MapMarkers}
        {(sectores && sectores.length) ? (
          geoJson.map((g, i) => {
            const sector = sectores[i]
            const map = JSON.parse(sector.mapa_geojson)
            const properties = map.features[0].properties
            return <Polyline key={sector.id} color={properties.color} positions={g} />
          })
        ) : (
          <div>
            <Marker position={geoJson[0]} icon={iconoSalida} />
            <Marker position={geoJson[geoJson.length - 1]} icon={iconoMeta} />
            <Polyline color={CONFIG.PRIMARY_COLOR} positions={geoJson} />
          </div>
        )}
      </Map>
      {MapMarkers.length === 0 &&
        <div className={'mapa__mensaje'}>
          *Los atletas aparecerán en cuanto atraviesen algún punto de control.*
        </div>
      }
    </div>
  }
}

export default MapaFavoritos



// WEBPACK FOOTER //
// ./src/components/MapaFavoritos.js